import React from "react";
import { Box, Button, Typography } from "@mui/material";

function Complete({ formData }) {
  return (
    <>
      <Box sx={{ textAlign: "center" }}>
        <img src="/img/mini_logo.png" alt="" />
        <Typography
          sx={{
            fontWeight: "500",
            fontSize: "20px",
            color: "#282828",
            mt: "48px",
            mb: "12px",
          }}
        >
          Congratulations, {formData.name}!
        </Typography>
        <Typography
          sx={{
            fontSize: "12px",
            color: "#282828",
            marginBottom: "44px",
          }}
        >
          You have completed registration, QuikSlip is spinning up an instance
          for you.
        </Typography>
        <Box sx={{ maxWidth: "400px", margin: "0 auto" }}>
          <Button
            variant="outlined"
            fullWidth
            sx={{
              backgroundColor: "#fff",
            }}
            href="https://buy.stripe.com/test_aFacN5gj82xR4cZ38jfYY00"
          >
            Launch QuikSlip
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default Complete;
